import React from 'react';
import { Clock, DollarSign, MapPin, ThumbsUp } from 'lucide-react';
const WhyItWorks = () => {
  const reasons = [{
    icon: <Clock size={24} className="text-[#b76e79]" data-id="element-203" />,
    title: 'Con poco tiempo',
    description: 'Rutinas rápidas que se adaptan a tu día a día ocupado.'
  }, {
    icon: <DollarSign size={24} className="text-[#b76e79]" data-id="element-204" />,
    title: 'Con presupuesto ajustado',
    description: 'Soluciones económicas y alternativas accesibles.'
  }, {
    icon: <MapPin size={24} className="text-[#b76e79]" data-id="element-205" />,
    title: 'Con necesidades latinas',
    description: 'Especialmente diseñado para pieles con tonos cálidos y clima húmedo.'
  }, {
    icon: <ThumbsUp size={24} className="text-[#b76e79]" data-id="element-206" />,
    title: 'Sin complicaciones',
    description: 'No necesitas experiencia, productos caros ni rutinas extensas.'
  }];
  return <section className="w-full py-16 md:py-24 bg-[#f6efe8]" data-id="element-207">
      <div className="container mx-auto px-4" data-id="element-208">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-209">
          <h2 className="text-3xl font-serif font-medium text-[#3a3a3a] mb-4" data-id="element-210">
            ¿Por qué funciona?
          </h2>
          <p className="text-lg text-[#5a5a5a]" data-id="element-211">
            Porque está hecho para mujeres reales como tú
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-212">
          {reasons.map((reason, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm" data-id="element-213">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#f8e9e6] mb-4" data-id="element-214">
                {reason.icon}
              </div>
              <h3 className="text-xl font-medium text-[#3a3a3a] mb-2" data-id="element-215">
                {reason.title}
              </h3>
              <p className="text-[#5a5a5a]" data-id="element-216">{reason.description}</p>
            </div>)}
        </div>
        <div className="mt-16 flex flex-col md:flex-row items-center gap-12" data-id="element-217">
          <div className="flex-1" data-id="element-218">
            <div className="bg-white p-4 rounded-lg shadow-xl max-w-md mx-auto" data-id="element-219">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eUyRcqtjapHVqi6LGzbfyS/Sonrisa_y_Belleza_en_Casa.png" alt="Belleza Latina" className="w-full h-auto object-contain" data-id="element-220" />
            </div>
          </div>
          <div className="flex-1 space-y-6" data-id="element-221">
            <h3 className="text-2xl font-serif font-medium text-[#3a3a3a]" data-id="element-222">
              Lo que te llevas hoy:
            </h3>
            <ul className="space-y-4" data-id="element-223">
              <li className="flex items-start gap-3" data-id="element-224">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#f8e9e6] mt-1" data-id="element-225">
                  <ThumbsUp size={14} className="text-[#b76e79]" data-id="element-226" />
                </div>
                <div data-id="element-227">
                  <p className="font-medium text-[#3a3a3a]" data-id="element-228">
                    Ebook completo (4 guías en 1)
                  </p>
                  <p className="text-sm text-[#5a5a5a]" data-id="element-229">
                    Todos los secretos de belleza en un solo lugar
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-230">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#f8e9e6] mt-1" data-id="element-231">
                  <ThumbsUp size={14} className="text-[#b76e79]" data-id="element-232" />
                </div>
                <div data-id="element-233">
                  <p className="font-medium text-[#3a3a3a]" data-id="element-234">
                    Kit de Belleza en Casa (GRATIS HOY)
                  </p>
                  <p className="text-sm text-[#5a5a5a]" data-id="element-235">
                    Guía completa para crear tu kit de belleza casero
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-236">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#f8e9e6] mt-1" data-id="element-237">
                  <ThumbsUp size={14} className="text-[#b76e79]" data-id="element-238" />
                </div>
                <div data-id="element-239">
                  <p className="font-medium text-[#3a3a3a]" data-id="element-240">
                    Planner de Belleza Económico (GRATIS HOY)
                  </p>
                  <p className="text-sm text-[#5a5a5a]" data-id="element-241">
                    Organiza tu rutina y lista de compras con productos
                    accesibles
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
};
export default WhyItWorks;